export const AddCircle = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M8 0.833008C11.958 0.833008 15.167 4.04196 15.167 8C15.167 11.958 11.958 15.167 8 15.167C4.04196 15.167 0.833008 11.958 0.833008 8C0.833008 4.04196 4.04196 0.833008 8 0.833008ZM8 1.83301C4.59424 1.83301 1.83301 4.59424 1.83301 8C1.83301 11.4058 4.59424 14.167 8 14.167C11.4058 14.167 14.167 11.4058 14.167 8C14.167 4.59424 11.4058 1.83301 8 1.83301ZM8 4.83301C8.27603 4.83301 8.49982 5.05701 8.5 5.33301V7.5H10.667C10.943 7.50018 11.167 7.72397 11.167 8C11.167 8.27603 10.943 8.49982 10.667 8.5H8.5V10.667C8.49982 10.943 8.27603 11.167 8 11.167C7.72397 11.167 7.50018 10.943 7.5 10.667V8.5H5.33301C5.05701 8.49982 4.83301 8.27603 4.83301 8C4.83301 7.72397 5.05702 7.50018 5.33301 7.5H7.5V5.33301C7.50018 5.05702 7.72397 4.83301 8 4.83301Z"
      fill="currentColor"
    />
  </svg>
);
